export default "__VITE_ASSET__AGIbjPKs__"